
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/product-registration/register-online-product",
      function () {
        return require("private-next-pages/my-account/product-registration/register-online-product.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/product-registration/register-online-product"])
      });
    }
  